export default "__VITE_ASSET__Djuc$$5a__"